module.exports = __webpack_public_path__ + "img/icon-tarjetas-outline.f5013eeb.svg";